(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kdh-collection-head"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const head = document.querySelector('.kdh-chead[data-sticky="true"]');
    if (!head) return;

    const setOffset = () => {
      const header = document.querySelector('#header-component, header.header, .header-section');
      let offset = 0;
      if (header) {
        const pos = getComputedStyle(header).position;
        if (pos === 'sticky' || pos === 'fixed') {
          offset = header.getBoundingClientRect().height;
        }
      }
      head.style.setProperty('--kdh-sticky-offset', `${Math.round(offset)}px`);
    };

    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });

    const active = head.querySelector('.kdh-chead__chip--active');
    if (active && window.innerWidth < 750) {
      active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'instant' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
